import { wsServices } from '../../../apis'

type ComboPaySubmitProgress = {
  type: 'COMBO_PAY_SUBMIT_PROGRESS'
}

type ComboPaySubmitCompleted = {
  type: 'COMBO_PAY_SUMBIT_COMPLETED'
}

const channelName = 'Payroll::ComboPaySynchronisationChannel'

export const useComboPaySubscription = wsServices.core.subscription.create({
  subscribePayload: () => ({
    channel: channelName
  }),
  messages: {
    onNotifySubmitProgress:
      wsServices.core.subscription.defineMessageHandler<ComboPaySubmitProgress>(
        {
          type: 'COMBO_PAY_SUBMIT_PROGRESS'
        }
      ),
    onNotifySubmitCompleted:
      wsServices.core.subscription.defineMessageHandler<ComboPaySubmitCompleted>(
        {
          type: 'COMBO_PAY_SUMBIT_COMPLETED'
        }
      )
  },
  emit: {
    submit: async context => {
      wsServices.core.ws.send({
        data: {
          action: 'submit',
          context
        },
        identifier: { channel: channelName }
      })
    }
  }
})
